import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import AppsIcon from "@material-ui/icons/Apps";

import { styles } from "./NavigationItemsStyles";
import ComunicacionItem from "./ComunicacionItem/ComunicacionItem";
import RepresentacionesItem from "./RepresentacionesItem/RepresentacionesItem";
import { ROL } from "../../../../constants";
import FolderSharedIcon from "@material-ui/icons/FolderShared";
import AdministracionItem from "./AdministracionItem/AdministracionItem";
import InformationIcon from "@material-ui/icons/InfoOutlined";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { isNative2 } from "../../../../utils/helper";
import DatosItem from "./DatosItem/DatosItem";

const routes = [
  {
    name: "Servicios",
    to: "/servicios",
    icon: AppsIcon,
  },
  {
    name: "Datos",
  },
  {
    name: "Mis Documentos",
    to: "/MisDocumentos",
    icon: FolderSharedIcon,
  },
  {
    name: "Comunicacion",
  },
  {
    name: "Representaciones",
  },
  {
    name: "Información Útil",
    to: "/informacion-util",
    icon: InformationIcon,
  },
  {
    name: "Configuración",
    to: "/configuracion-notificaciones",
    icon: NotificationsIcon,
  },
  {
    name: "Administracion",
  },
];

interface OwnProps {
  handleDrawerToggle: () => void;
}
type PublicProps = OwnProps;

const mapStateToProps = (state: any) => ({
  roles: state.usuario.roles,
  usuario: state.usuario.user,
});
const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PublicProps & PropsFromRedux & WithStyles<typeof styles>;

const NavigationItems: React.FC<Props> = (props) => {
  const { classes, roles, handleDrawerToggle, usuario } = props;
  const [esNativo, setEsNativo] = useState(false);

  useEffect(() => {
    const checkIsNative = async () => {
      const result = await isNative2();
      setEsNativo(result);
    };
    checkIsNative();
  }, []);

  const canAccessExternalLinks = roles.some(
    (rol: any) => rol.nombre.toUpperCase() === ROL
  );

  return (
    <List>
      {routes
        .filter((route) => 
          (route.name !== "Información Útil" || esNativo) &&
          (route.name !== "Configuración" || esNativo)
        )
        .map((route: any) => {
          if (route.name === "Comunicacion") {
            //este componente se puede expandir si el usuario logueado tiene rol 'COMUNICADOR'
            return (
              <ComunicacionItem
                key={route.name}
                canAccessExternalLinks={canAccessExternalLinks}
                handleDrawerToggle={handleDrawerToggle}
              />
            );
          }

          if (route.name === "Datos") {
            if (usuario.rol < 4) return null;
            return (
              <DatosItem
                key={route.name}
                handleDrawerToggle={handleDrawerToggle}
              />
            );
          }

          if (route.name === "Representaciones") {
            return (
              <RepresentacionesItem
                key={route.name}
                handleDrawerToggle={handleDrawerToggle}
              />
            );
          }

          if (route.name === "Administracion") {
            if (usuario.rol === 0) return null;
            return (
              <AdministracionItem
                key={route.name}
                handleDrawerToggle={handleDrawerToggle}
              />
            );
          }

          if (route.name === "Datos" && usuario.rol < 4) return null;

          return (
            <NavLink
              to={route.to}
              style={{ textDecoration: "none", color: "inherit" }}
              key={route.name}
            >
              {({ isActive }) => (
                <ListItem
                  button
                  key={route.name}
                  className={`${classes.listItem} ${
                    isActive ? classes.activeListItem : ""
                  }`}
                  onClick={handleDrawerToggle}
                >
                  <ListItemIcon>
                    <route.icon />
                  </ListItemIcon>
                  <ListItemText primary={route.name} />
                </ListItem>
              )}
            </NavLink>
          );
        })}
    </List>
  );
};
export default connector(
  withStyles(styles)(NavigationItems)
) as React.ComponentType<PublicProps>;
